import React, { useEffect, useState } from 'react'
import { Box, Button, Typography, IconButton, useTheme } from '@material-ui/core'
import FormUpdate from './FormUpdate'
import { ArrowBack } from '@material-ui/icons'
import { Link, useHistory } from 'react-router-dom'
import { useTranslate, useDataProvider, Loading } from 'react-admin'
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import DeleteIcon from '../assets/icons/primary-blue-bin.png'
import GoBackButton from '../CustomizedUIs/GoBackButton'

const EditChannel = (props) => {
    const dataProvider = useDataProvider()
    const theme = useTheme();
    const [name, setName] = useState('');
    const history = useHistory()
    const [data, setData] = useState()
    const translate = useTranslate();
    const [loading, setLoading] = useState(true)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

    const getData = () => {
        setLoading(true)
        dataProvider('GET_LIST', "Services", {
            filter: {
                id: parseInt(props.match.params.id)
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'createdAt', order: 'ASC' },

        })
            .then(({ data }) => {
                if (data) {
                    console.log(data[0])
                    setData(data[0]);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }

    useEffect(() => {
        getData()
    }, [])

    if (loading) return null

    return (
        <Box width='80%' m='auto'>
            <Box my={5} width={300} display='flex' component={Link} to={'/ExternalService'} style={{ textDecoration: 'none' }}>
                <Box display='flex' mr={2}>
                    <GoBackButton />
                </Box>
                <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>Back to external services</Typography>
            </Box>
            <Box display='flex' justifyContent='center' mt={10}>
                <Box width={500}>

                    <Box display='flex'>
                        <Typography style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }} variant='h5'>{translate(`pos.channels.editting`) + data.name}</Typography>

                    </Box>

                    <Box>
                        <FormUpdate setShowSnackbar={props.setShowSnackbar} data={data} id={data.id} />
                    </Box>
                </Box>
            </Box>

        </Box>
    )
}
export default EditChannel